import { chakra } from '@chakra-ui/react';
import React from 'react';

import { Alert } from 'toolkit/chakra/alert';
import { useTranslation } from 'next-i18next';

const DataFetchAlert = ({ className }: { className?: string }) => {
  const { t } = useTranslation('common');

  return (
    <Alert status="warning" width="fit-content" className={ className }>
      {t('Something went wrong. Try refreshing the page or come back later.')}
    </Alert>
  );
};

export default chakra(DataFetchAlert);
